module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_yogiyo.9b19a643f433878005940ce0f826df40.png";